<template>
    <b-container>
        <h1>New Direct Message Inbox</h1>
        <label for="participant" class="font-weight-bold">Start a direct message chat with: </label>
        <b-form-radio-group
        id="radio-group-1"
        v-model="participant"
        :options="users"        
        name="radio-options"
        stacked
      ></b-form-radio-group>
      <b-button @click="onSubmit" id="submitButton" class="mt-3" variant="primary">{{ button_label }}</b-button>
    </b-container>
</template>


<script>

    import UserDataService from '@/services/UserDataService'
    import InboxDataService from '@/services/InboxDataService'

    export default {
        data() {
            return {
                subject: '',
                body: '',
                users: [],
                participant:'',
                action: 'create',
                button_label: 'Start Chatting!'
            }
        },
        created() {
            UserDataService.getActiveUsers()
                .then(response => {
                    this.users = response.data;
                })
                .catch(e => {
                    console.log(e);
                });

        },
        methods: {
            onSubmit() {
                document.getElementById('submitButton').disabled = true

                let participants = [];
                
                participants.push(this.participant);

                this.users.forEach(user => {
                        if(user.text == localStorage.getItem('name')) {
                            participants.push(user.value)
                        }
                    })

                InboxDataService.create({
                    subject: 'direct',
                    body: this.body,
                    participants: participants
                }).then((inbox) => {
                    this.$emit("alert", 
                    { variant: "success", message: `<a href="/inbox/message/${inbox.id}">Inbox ${inbox.subject}</a> created successfully` });  
                })
                
            },
            onReset() {
                this.message = ''
            }
        }
    }
</script>